/* eslint-disable react/display-name */
import React from 'react'
import { withTranslation } from 'react-i18next'
import { Container, Grid } from '@mui/material'
import TippingComponent from '../components/Tipping/Tipping'
// core components
import Header from '../components/Headers/Header'
import useGlobalStyles from '../utils/globalStyles'

function Tipping() {
  const globalClasses = useGlobalStyles()
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className={globalClasses.flex} fluid>
        <Grid container>
          <Grid item xs={12} order={{ xs: 2, md: 1 }}>
            <TippingComponent />
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default withTranslation()(Tipping)
